import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'
import { UnitFileData } from './unitBase'
import { AttachInfo, emptyAttach } from '../common/attach'
const apiUrl = `${urlPrefix}/UnitFour`
//#region 基本信息
const GetInfo = (id: number) => `${apiUrl}/${id}`

//附属文物
const GetRelic = (id: number) => `${apiUrl}/relic/${id}`
const GetRelicList = (unitId: number) => `${apiUrl}/relicList/${unitId}`
const PutRelic = (id: number) => `${apiUrl}/relic/${id}`
const DelRelic = (id: number) => `${apiUrl}/relic/${id}`
//文物藏品
const GetCollection = (id: number) => `${apiUrl}/collection/${id}`
const GetCollectionList = (unitId: number) => `${apiUrl}/collectionList/${unitId}`
const PutCollection = (id: number) => `${apiUrl}/collection/${id}`
const DelCollection = (id: number) => `${apiUrl}/collection/${id}`
//古树名木
const GetTree = (id: number) => `${apiUrl}/tree/${id}`
const GetTreeList = (unitId: number) => `${apiUrl}/treeList/${unitId}`
const PutTree = (id: number) => `${apiUrl}/tree/${id}`
const DelTree = (id: number) => `${apiUrl}/tree/${id}`
//图纸卷，照片卷
const GetFile = (id: number) => `${apiUrl}/file/${id}`
const GetFileList = (unitId: number) => `${apiUrl}/fileList/${unitId}`
const PutFile = (id: number) => `${apiUrl}/file/${id}`
const DelFile = (id: number) => `${apiUrl}/file/${id}`
//拓片及摹本
const GetRubbing = (id: number) => `${apiUrl}/rubbing/${id}`
const GetRubbingList = (unitId: number, category: number) => `${apiUrl}/rubbingList/${unitId}/${category}`
const PutRubbing = (id: number) => `${apiUrl}/rubbing/${id}`
const DelRubbing = (id: number) => `${apiUrl}/rubbing/${id}`
//各种卷
const GetVolume = (id: number) => `${apiUrl}/volume/${id}`
const GetVolumeList = (unitId: number, category: number) => `${apiUrl}/volumeList/${unitId}/${category}`
const PutVolume = (id: number) => `${apiUrl}/volume/${id}`
const DelVolume = (id: number) => `${apiUrl}/volume/${id}`
//#endregion
export const emptyUnitFour: UnitFourData = {
    UnitId: 0,
    AttachTypePic: 0,
    AttachTypeRubbing: 0,
    AttachTypeVolume: 0,

    RelicList: [],
    CollectionList: [],
    TreeList: [],
    Pictures: [],
    Drawings: [],

    RubbingList1: [],
    RubbingList2: [],

    VolumeList101: [],
    VolumeList102: [],
    VolumeList103: [],
    VolumeList104: [],
    VolumeList105: [],
    VolumeList106: [],
    VolumeList199: [],

    VolumeList201: [],
    VolumeList202: [],
    VolumeList203: [],
    VolumeList299: [],

    VolumeList301: [],
    VolumeList302: [],
    VolumeList303: [],
    VolumeList399: []
}
export interface UnitFourData {
    UnitId: number
    AttachTypePic: number
    AttachTypeRubbing: number
    AttachTypeVolume: number

    RelicList: FourRelicData[],
    CollectionList: FourCollectionData[],
    TreeList: FourTreeData[],
    Pictures: UnitFileData[],
    Drawings: UnitFileData[],

    RubbingList1: FourRubbingData[],
    RubbingList2: FourRubbingData[],

    VolumeList101: FourVolumeData[],
    VolumeList102: FourVolumeData[],
    VolumeList103: FourVolumeData[],
    VolumeList104: FourVolumeData[],
    VolumeList105: FourVolumeData[],
    VolumeList106: FourVolumeData[],
    VolumeList199: FourVolumeData[],

    VolumeList201: FourVolumeData[],
    VolumeList202: FourVolumeData[],
    VolumeList203: FourVolumeData[],
    VolumeList299: FourVolumeData[],

    VolumeList301: FourVolumeData[],
    VolumeList302: FourVolumeData[],
    VolumeList303: FourVolumeData[],
    VolumeList399: FourVolumeData[]
}

//region 附属文物
export const emptyFourRelic: FourRelicData = {
    Id: 0,
    UnitId: 0,
    RelicCode: '',
    RelicName: '',
    Age: '',
    Quantity: 0,
    DamagedId: 0,
    Position: '',
    Description: '',
    SubSeq: 0,
    Status: 1,
    NewUserId: 0,
    NewDate: new Date(),
    UpdateUserId: 0,
    UpdateDate: new Date(),
    DamagedName: ''
}
export interface FourRelicData {
    [key: string]: any
    Id: number
    UnitId: number
    RelicCode: string
    RelicName: string
    Age: string
    Quantity: number
    DamagedId: number
    Position: string
    Description: string
    SubSeq: number
    Status: number
    NewUserId: number
    NewDate: Date
    UpdateUserId: number
    UpdateDate: Date
    DamagedName: string
}
export const getRelicList = (unitId: number) => {
    return tryAxios({
        method: 'get',
        url: GetRelicList(unitId)
    })
}
export const getRelic = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetRelic(id),
    })
}
export const putRelic = (id: number, form: FourRelicData) => {
    return tryAxios({
        method: 'put',
        url: PutRelic(id),
        data: form
    })
}
export const removeRelic = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: DelRelic(id)
    })
}
//#endregion
//region 文物藏品
export const emptyFourCollection: FourCollectionData = {
    Id: 0,
    UnitId: 0,
    CollectionCode: '',
    CollectionName: '',
    Age: '',
    Quantity: 0,
    TextureId: 0,
    DamagedId: 0,
    Source: '',
    Description: '',
    SubSeq: 0,
    Status: 1,
    NewUserId: 0,
    NewDate: new Date(),
    UpdateUserId: 0,
    UpdateDate: new Date(),

    TextureName: '',
    DamagedName: ''
}
export interface FourCollectionData {
    [key: string]: any
    Id: number
    UnitId: number
    CollectionCode: string
    CollectionName: string
    Age: string
    Quantity: number
    TextureId: number
    DamagedId: number
    Source: string
    Description: string
    SubSeq: number
    Status: number
    NewUserId: number
    NewDate: Date
    UpdateUserId: number
    UpdateDate: Date

    TextureName: string
    DamagedName: string
}
export const getCollectionList = (unitId: number) => {
    return tryAxios({
        method: 'get',
        url: GetCollectionList(unitId)
    })
}
export const getCollection = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetCollection(id),
    })
}
export const putCollection = (id: number, form: FourCollectionData) => {
    return tryAxios({
        method: 'put',
        url: PutCollection(id),
        data: form
    })
}
export const removeCollection = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: DelCollection(id)
    })
}
//#endregion
//region 古树名木
export const emptyFourTree: FourTreeData = {
    Id: 0,
    UnitId: 0,
    TreeCode: '',
    TreeName: '',
    ScientificName: '',
    Age: 0,
    Position: '',
    Height: 0,
    Width: 0,
    Description: '',
    SubSeq: 0,
    Status: 1,
    NewUserId: 0,
    NewDate: new Date(),
    UpdateUserId: 0,
    UpdateDate: new Date(),
}
export interface FourTreeData {
    [key: string]: any
    Id: number
    UnitId: number
    TreeCode: string
    TreeName: string
    ScientificName: string
    Age: number
    Position: string
    Height: number
    Width: number
    Description: string
    SubSeq: number
    Status: number
    NewUserId: number
    NewDate: Date
    UpdateUserId: number
    UpdateDate: Date
}
export const getTreeList = (unitId: number) => {
    return tryAxios({
        method: 'get',
        url: GetTreeList(unitId)
    })
}
export const getTree = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetTree(id),
    })
}
export const putTree = (id: number, form: FourTreeData) => {
    return tryAxios({
        method: 'put',
        url: PutTree(id),
        data: form
    })
}
export const removeTree = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: DelTree(id)
    })
}
//#endregion

//region 图纸卷，照片卷
export const getFileList = (unitId: number) => {
    return tryAxios({
        method: 'get',
        url: GetFileList(unitId)
    })
}
export const getFile = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetFile(id),
    })
}
export const putFile = (id: number, form: UnitFileData) => {
    return tryAxios({
        method: 'put',
        url: PutFile(id),
        data: form
    })
}
export const removeFile = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: DelFile(id)
    })
}
//#endregion
//region 拓片及摹本
export const emptyFourRubbing: FourRubbingData = {
    Id: 0,
    UnitId: 0,
    Category: 0,
    RubbingCode: '',
    RubbingName: '',
    Quantity: 0,
    Height: 0,
    Width: 0,
    ExistingState: '',
    CreatedBy: '',
    CreatedDate: new Date(),
    Recordings: '',
    Description: '',
    SubSeq: 0,
    Status: 1,
    NewUserId: 0,
    NewDate: new Date(),
    UpdateUserId: 0,
    UpdateDate: new Date(),

    AttachId: 0,
    AttachType: 0,
    AttachGuid: '',
    AttInfo: emptyAttach
}
export interface FourRubbingData {
    [key: string]: any
    Id: number
    UnitId: number
    Category: number
    RubbingCode: string
    RubbingName: string
    Quantity: number
    Height: number
    Width: number
    ExistingState: string
    CreatedBy: string
    CreatedDate: Date
    Recordings: string
    Description: string
    SubSeq: number
    Status: number
    NewUserId: number
    NewDate: Date
    UpdateUserId: number
    UpdateDate: Date

    AttachId: number
    AttachType: number
    AttachGuid: string
    AttInfo: AttachInfo
}
export const getRubbingList = (unitId: number, category: number) => {
    return tryAxios({
        method: 'get',
        url: GetRubbingList(unitId, category)
    })
}
export const getRubbing = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetRubbing(id),
    })
}
export const putRubbing = (id: number, form: FourRubbingData) => {
    return tryAxios({
        method: 'put',
        url: PutRubbing(id),
        data: form
    })
}
export const removeRubbing = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: DelRubbing(id)
    })
}
//#endregion
//region 各种卷
export const emptyFourVolume: FourVolumeData = {
    Id: 0,
    UnitId: 0,
    Category: 0,
    Name: '',
    Description: '',
    SubSeq: 0,
    Status: 1,
    NewUserId: 0,
    NewDate: new Date(),
    UpdateUserId: 0,
    UpdateDate: new Date(),

    AttachId: 0,
    AttachType: 0,
    AttachGuid: '',
    AttInfo: emptyAttach
}
export interface FourVolumeData {
    [key: string]: any
    Id: number
    UnitId: number
    Category: number
    Name: string
    Description: string
    SubSeq: number
    Status: number
    NewUserId: number
    NewDate: Date
    UpdateUserId: number
    UpdateDate: Date

    AttachId: number
    AttachType: number
    AttachGuid: string
    AttInfo: AttachInfo
}
export const getVolumeList = (unitId: number, category: number) => {
    return tryAxios({
        method: 'get',
        url: GetVolumeList(unitId, category)
    })
}
export const getVolume = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetVolume(id),
    })
}
export const putVolume = (id: number, form: FourVolumeData) => {
    return tryAxios({
        method: 'put',
        url: PutVolume(id),
        data: form
    })
}
export const removeVolume = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: DelVolume(id)
    })
}
//#endregion

export const getInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetInfo(id),
    })
}